import React, { useState } from 'react';
import { graphInfoTexts } from '../constants/graphInfoTexts';
import { formInfoTexts } from '../constants/formInfoTexts';
import './InfoButton.css';

const InfoButton = ({ infoKey }) => {
  const [open, setOpen] = useState(false);
  // Deux tables : les graphiques des pages de suivi, et les champs du
  // questionnaire quotidien (clés préfixées `form`).
  const text = graphInfoTexts[infoKey] ?? formInfoTexts[infoKey];
  if (!text) return null;

  return (
    <>
      <button
        className="info-btn"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        aria-label="Plus d'informations"
        title="Plus d'informations"
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.3" />
          <circle cx="8" cy="4.9" r="0.95" fill="currentColor" />
          <line x1="8" y1="7" x2="8" y2="11.3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </button>

      {open && (
        <div className="info-btn__backdrop" onClick={() => setOpen(false)}>
          <div className="info-btn__dialog" onClick={(e) => e.stopPropagation()}>
            <p className="info-btn__text">{text}</p>
            <button className="info-btn__close" onClick={() => setOpen(false)}>Fermer</button>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoButton;
